import { render } from "./contactus.vue?vue&type=template&id=6d779bd4&scoped=true"
import script from "./contactus.vue?vue&type=script&lang=js"
export * from "./contactus.vue?vue&type=script&lang=js"

import "./contactus.vue?vue&type=style&index=0&id=6d779bd4&scoped=true&lang=less"

import exportComponent from "D:\\STD7159\\源码管理\\前端\\stgd.oa.ows.inernetweb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d779bd4"]])

export default __exports__